import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import GridList from '@material-ui/core/GridList';
import CardActionArea from '@material-ui/core/CardActionArea';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from './EmpresaRegisterContactsStyles';
import ProgressFullScreen from '../../../../components/Compartilhados/ProgressFullScreen';
import InputMask from 'react-input-mask';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import { TiposTelefoneValues } from '../../../../values/TipoTelefonesValues';
import MenuItem from '@material-ui/core/MenuItem';
import DialogEditEndereco from './DialogEditEndereco';
import DialogEditTelefone from './DialogEditTelefone';

const timeout = ServiceValues.timeout;

function EmpresaRegisterContacts(props) {
  const {
    className,
    history,
    user,
    empresa,
    setEmpresa,
    showMessageSnack,
    setShowMessageSnack,
    messageSnack,
    setMessageSnack,
    typeSnack,
    setTypeSnack,
    edicao,
    ...rest } = props;
  const [refreshState, setRefreshState] = useState('');
  const [loading, setLoading] = useState(false);
  const [cepEmpresa, setCepEmpresa] = useState('');
  const [rua, setRua] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [codigoIbge, setcodigoIbge] = useState('');
  const [apelido_endereco, setApelido_endereco] = useState('');
  const [codigoPais, setCodigoPais] = useState('+55');
  const [ddd, setDdd] = useState('');
  const [numeroTelefone, setNumeroTelefone] = useState('');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [maskCep, setMaskCep] = useState('99.999-999');
  const [maskDDD, setMaskDDD] = useState('(99)');
  const [maskTelCel, setMaskTelCel] = useState('9.9999-9999');
  const [tipoTelefone, setTipoTelefone] = useState('');
  const [openDialogEditEndereco,setOpenDialogEditEndereco] = useState(false);
  const [indexEnderecoSelecionado, setIndexEnderecoSelecionado] = useState(-1);
  const [openDialogEditTelefone,setOpenDialogEditTelefone] = useState(false);
  const [indexTelefoneSelecionado, setIndexTelefoneSelecionado] = useState(-1);
  const classes = useStyles();

  async function consultarCep(value) {
    try{
      setLoading(true);
      // const informacoesEndereco = await cep(value);
      const api = ServiceAxios('https://viacep.com.br/ws/', timeout);
      const informacoesEndereco = await api.get('/' + value + '/json/');
      if(informacoesEndereco.data.erro){
        setLoading(false);
        setMessageSnack('Erro ao obter informações para o CEP informado.');
        setTypeSnack('error');
        setShowMessageSnack('success');
      }
      else{
        setBairro(informacoesEndereco.data.bairro);
        setCidade(informacoesEndereco.data.localidade);
        setRua(informacoesEndereco.data.logradouro);
        setEstado(informacoesEndereco.data.uf);
        setcodigoIbge(informacoesEndereco.data.ibge);
        setLoading(false);
      }
    }
    catch (e) {
      setLoading(false);
      setMessageSnack('Erro ao obter informações para o CEP informado.');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function abrirDialog () {
    setOpenDialog(!openDialog);
  }


  function adicionarEndereco() {
    const novoEndereco = {
      logradouro: rua,
      numero: numero,
      bairro: bairro,
      complemento: complemento,
      cep: cepEmpresa,
      uf: estado,
      cidade: cidade,
      codigoIbge: codigoIbge,
      apelido: apelido_endereco,
      pais: "Brasil"
    };
    empresa.enderecos.push(novoEndereco);
    setEmpresa(empresa);
    setRua('');
    setCepEmpresa('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setCidade('');
    setEstado('');
    setApelido_endereco('');
    setcodigoIbge('');
  }

  function adicionarTelefone() {

    const novoTelefone = {
      codigo_pais: codigoPais,
      ddd: ddd,
      telefone: numeroTelefone,
      tipo_telefone: tipoTelefone,
      telefone_fixo: tipoTelefone.telefone_fixo
    };
    empresa.telefones.push(novoTelefone);
    setEmpresa(empresa);
    setDdd('');
    setNumeroTelefone('');
    setTipoTelefone('');
  }

  function removerEndereco(event, index) {
    if(edicao){
      empresa.enderecos[index].cep = undefined;
      setEmpresa(empresa);
      setRefreshState(new Date());
    }
    else{
      empresa.enderecos.splice(index, 1);
      setEmpresa(empresa);
      setRefreshState((new Date).toString());
    }

  }

  function removerTelefone(event, index) {
    if(edicao){
      empresa.telefones[index].telefone = undefined;
      setEmpresa(empresa);
      setRefreshState(new Date());
    }
    else{
      empresa.telefones.splice(index, 1);
      setEmpresa(empresa);
      setRefreshState((new Date).toString());
    }
  }

  function editEndereco(index) {
    setIndexEnderecoSelecionado(index);
    setOpenDialogEditEndereco(true);
  }

  function editTelefone(index) {
    setIndexTelefoneSelecionado(index);
    setOpenDialogEditTelefone(true);

  }

  return (
    <div>
      <DialogEditEndereco
        usuario={empresa}
        setEmpresa={setEmpresa}
        open={openDialogEditEndereco}
        setOpen={setOpenDialogEditEndereco}
        index_endereco={indexEnderecoSelecionado}
        setIndex_endereco={setIndexEnderecoSelecionado}
      />
      <DialogEditTelefone
        empresa={empresa}
        setEmpresa={setEmpresa}
        open={openDialogEditTelefone}
        setOpen={setOpenDialogEditTelefone}
        index_telefone={indexTelefoneSelecionado}
        setIndex_telefone={setIndexTelefoneSelecionado}
      />
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <ValidatorForm
        autoComplete="off"
        onSubmit={adicionarEndereco}
      >


        <CardHeader
          subheader="Informe os seguintes dados para adicionar um endereço"
          title="Endereços"
        />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={2}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Apelido"
                helperText="Insira um apelido para seu endereço."
                onChange={e => setApelido_endereco(e.target.value)}
                value={apelido_endereco}
                margin="dense"
                name="apelido_endereco"
                variant="outlined"
                validators={['required']}
                errorMessages={['Informe um apelido para seu endereço.!']}
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
            >
              <InputMask
                mask={maskCep}
                value={cepEmpresa}
                onChange={e => setCepEmpresa(e.target.value.replace('.', '').replace('-', ''))}
                onBlur={e => consultarCep(e.target.value.replace('.', '').replace('-', ''))}
              >
                {
                  (inputProps) =>
                    <TextValidator
                      fullWidth
                      label="CEP"
                      helperText="Insira o CEP."
                      margin="dense"
                      name="cep"
                      onChange={inputProps.onChange}
                      onBlur={inputProps.onBlur}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe o CEP!']}
                    />
                }
              </InputMask>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Rua"
                helperText="Insira a rua."
                margin="dense"
                name="rua"
                onChange={e => setRua(e.target.value)}
                value={rua}
                variant="outlined"
                validators={['required']}
                errorMessages={['Informe a rua!']}
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Número"
                helperText="Número."
                onChange={e => setNumero(e.target.value)}
                value={numero}
                margin="dense"
                name="numero"
                variant="outlined"
                validators={['required']}
                errorMessages={['Informe o número!']}
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Complemento"
                helperText="Insira um complemento."
                margin="dense"
                name="complemento"
                variant="outlined"
                onChange={e => setComplemento(e.target.value)}
                value={complemento}
                validators={['maxStringLength:70']}
                errorMessages={['Complemeto muito longo!']}
              />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Bairro"
                helperText="Insira o bairro."
                margin="dense"
                name="bairro"
                variant="outlined"
                onChange={e => setBairro(e.target.value)}
                value={bairro}
                validators={['required']}
                errorMessages={['Informe o bairro!']}
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Cidade"
                onChange={e => setCidade(e.target.value)}
                value={cidade}
                helperText="Insira a cidade."
                margin="dense"
                name="cidade"
                variant="outlined"
                validators={['required']}
                errorMessages={['Informe a cidade!']}
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Estado"
                helperText="Estado."
                margin="dense"
                name="estado"
                onChange={e => setEstado(e.target.value)}
                value={estado}
                variant="outlined"
                validators={['required']}
                errorMessages={['Informe o estado!']}
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Código IBGE"
                helperText="Código IBGE do seu endereço."
                margin="dense"
                name="codigoIbge"
                disabled
                value={codigoIbge}
                variant="outlined"
                validators={['required']}
                errorMessages={['Informe o estado!']}
              />
            </Grid>

            <Grid
              item
              md={3}
              xs={12}
            >
              <div style={{display: 'flex',  justifyContent:'flex-end', alignItems:'center'}}>

                <CardActions>
                  <Button
                    color="primary"
                    type="submit"
                    variant="contained"
                  >
                    Adicionar Endereço
                  </Button>
                </CardActions>
              </div>
            </Grid>
          </Grid>
        </CardContent>

        <GridList className={classes.gridList} cols={5} spacing={10}>
          {empresa.enderecos.map((endereco, index) => (
            endereco.cep &&
            <Card className={classes.card} key={index}>
              <CardActionArea
                onClick={e => editEndereco(index)}
              >

                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    {endereco.apelido}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {"CEP: " + endereco.cep}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {endereco.logradouro + ", " + endereco.numero + ", " + endereco.bairro + ", " + endereco.complemento +
                    ", " + endereco.cidade + " - " + endereco.uf}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {"Código IBGE: " + endereco.codigoIbge}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <IconButton
                  aria-label="delete"
                  className={classes.expand}
                  onClick={e => removerEndereco(e, index)}

                >
                  <DeleteIcon
                    fontSize={'small'}
                    color={'action'}
                  />
                </IconButton>
              </CardActions>
            </Card>
          ))}
        </GridList>
        <Divider />
      </ValidatorForm>
      <ValidatorForm
        autoComplete="off"
        onSubmit={adicionarTelefone}
      >

        <CardHeader
          subheader="Informe os seguintes dados para adicionar um telefone"
          title="Telefones"
        />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={2}
              xs={12}
            >
              <InputMask
                mask={maskDDD}
                value={ddd}
                onChange={e => setDdd(e.target.value.replace('(', '').replace(')', ''))}
              >
                {
                  (inputProps) =>
                    <TextValidator
                      fullWidth
                      label="DDD"
                      helperText="Insira o DDD."
                      margin="dense"
                      name="ddd"
                      onChange={inputProps.onChange}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe o DDD!']}
                    />
                }
              </InputMask>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <InputMask
                mask={maskTelCel}
                value={numeroTelefone}
                onChange={e => setNumeroTelefone(e.target.value.replace('.', '').replace('-', ''))}
              >
                {
                  (inputProps) =>
                    <TextValidator
                      fullWidth
                      label="Número"
                      helperText="Insira a número do telefone."
                      margin="dense"
                      name="telefone"
                      onChange={inputProps.onChange}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe o número do numeroTelefone!']}
                    />
                }
              </InputMask>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <SelectValidator
                fullWidth
                helperText="Insira o tipo de telefone!"
                label="Tipo de Telefone"
                margin="dense"
                name="id_sistema"
                onChange={e => setTipoTelefone(e.target.value)}
                value={tipoTelefone}
                variant="outlined"
                validators={['required']}
                errorMessages={['Insira o tipo de telefone!']}
              >
                {TiposTelefoneValues.map((tipo, index) => (
                  <MenuItem value={tipo} key={index}>{tipo.label}</MenuItem>
                ))}

              </SelectValidator>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <div style={{display: 'flex',  justifyContent:'flex-end', alignItems:'center'}}>

                <CardActions>
                  <Button
                    color="primary"
                    type="submit"
                    variant="contained"
                  >
                    Adicionar Telefone
                  </Button>
                </CardActions>
              </div>
            </Grid>
          </Grid>
        </CardContent>

        <GridList className={classes.gridList} cols={5} spacing={10}>
          {empresa.telefones.map((telefone, index) => (
            telefone.telefone && <Card className={classes.card}>
              <CardActionArea
                onClick={e => editTelefone(index)}
              >

                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2" >
                    {"Telefone " + (index + 1)}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {"(" + telefone.ddd + ") " + telefone.telefone }
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {telefone.telefone_fixo ? 'Telefone Fixo' : 'Telefone Celular'}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <IconButton
                  aria-label="delete"
                  className={classes.expand}
                  onClick={e => removerTelefone(e, index)}

                >
                  <DeleteIcon
                    fontSize={'small'}
                    color={'action'}
                  />
                </IconButton>
              </CardActions>
            </Card>
          ))}
        </GridList>
        <Divider />
      </ValidatorForm>
    </div>

  );
};

EmpresaRegisterContacts.propTypes = {
  className: PropTypes.string,
  empresa: PropTypes.object.isRequired
};

export default EmpresaRegisterContacts;


